// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles__tableContainer--x8Ole","tableNotCollapsed":"styles__tableNotCollapsed--r8jR3","testReportContainer":"styles__testReportContainer--ivEXi"};